import Vue from 'vue'
import IdleVue from 'idle-vue'
import VueAnalytics from 'vue-analytics'
import VueApexCharts from 'vue-apexcharts'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/store'

Vue.component( 'apexchart', VueApexCharts );

// user idle detection
Vue.use( IdleVue, {
	store,
	idleTime: 1000,
	events: [ 'mousemove', 'keydown', 'mousedown', 'touchstart', 'wheel' ]
} );

Vue.use( VueAnalytics, {
	id: 'UA-2055162-7',
//	debug: {
//		sendHitTask: false
//	},
	router
} );

Vue.config.productionTip = false;

new Vue( {
	router,
	store,
	render: h => h( App )
} ).$mount( '#app' )
